import { useEffect, useState } from "react";
import {
  Tabs,
  Container,
  ScrollArea,
  Card,
  Text,
  CardSection,
  Box,
  Grid,
  Image,
  LoadingOverlay,
  useMantineTheme,
  Badge,
} from "@mantine/core";
import "../../Pages/Dashboard.css";
import Toast from "./../Toast";
import { fetchMentorMenteesApi } from "./../../api/dashboard";
import { useMediaQuery } from "@mantine/hooks";
import { ContactCards } from "./Contact";

async function fetchMentorMentees() {
  const res = await fetchMentorMenteesApi().catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res != null) {
    if (res.status == 200) {
      return res.data;
    } else {
      Toast("ERROR", res.data.message, "red");
      return [];
    }
  } else return [];
}
export const Mentors = () => {
  const [data, setdata] = useState([]);
  const [dataLoad, setdataLoad] = useState(true);
  var user = data;
  const isScreenLarge = useMediaQuery("(min-width: 400px)", false);
  var theme = useMantineTheme();
  useEffect(() => {
    fetchMentorMentees().then((res) => {
      setdata(res);
      setdataLoad(false);
    });
  }, []);

  if (dataLoad == true) {
    return (
      <Card>
        <LoadingOverlay visible={dataLoad} />
      </Card>
    );
  } else if (user.length == 0) {
    return (
      <Text className="Mentor-style" style={{ padding: "5px" }}>
        Mentee-Mentor Assignment is yet to be done
      </Text>
    );
  } else {
    if (!user.isMentor) {
      return (
        <>
          <Container
            style={{
              marginTop: 35,
              width: "100%",
              paddingLeft: "0px",
              paddingRight: "0px",
            }}
          >
            <Text className="Mentor-style">Mentors</Text>
            <Box
              sx={(theme) => ({
                backgroundColor:
                  theme.colorScheme === "dark"
                    ? theme.colors.dark[6]
                    : theme.colors.gray[2],
                textAlign: "center",
                padding: theme.spacing.xl,
                // borderRadius: theme.radius.md,
                cursor: "pointer",
                height: 420,

                "&:hover": {
                  backgroundColor:
                    theme.colorScheme === "dark"
                      ? theme.colors.dark[6]
                      : theme.colors.gray[3],
                },
              })}
            >
              <ScrollArea style={{ height: 400 }} offsetScrollbars>
                <Grid justify="space-around">
                  {user.mentors?.map((mentor) => {
                    return (
                      <CardSection
                        key={String(mentor.mentor.id) + String(mentor.domain)}
                        style={{ margin: 10 }}
                      >
                        <Card
                          style={{
                            height: 355,
                            width: isScreenLarge == false ? 240 : 275,
                            borderRadius: 15,
                            marginBottom: 25,
                            backgroundColor:
                              theme.colorScheme === "dark"
                                ? theme.colors.dark[8]
                                : "white",
                          }}
                        >
                          <Image
                            src={
                              mentor.mentor.gender == "FEMALE"
                                ? "/female.png"
                                : "/male.png"
                            }
                            height={150}
                            width={150}
                            radius="md"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          />
                          <Text
                            style={{
                              fontSize: 18,
                              textAlign: "left",
                              marginTop: 10,
                            }}
                          >
                            Name: {mentor.mentor.name}
                          </Text>

                          <Text
                            style={{
                              fontSize: 16,
                              textAlign: "left",
                              marginTop: 12,
                            }}
                          >
                            Phone Number: {mentor.mentor.phone}
                          </Text>
                          
                          <Badge
                            color={"gray"}
                            style={{
                              marginTop: 25,
                              fontSize: 16,
                              textAlign: "left",
                            }}
                          >
                            {mentor.domain}
                          </Badge>
                          {/* <Text
                            style={{
                              marginTop: 10,
                              fontSize: 16,
                              textAlign: "center",
                              borderTop: "2px solid black",
                            }}
                          >
                            {mentor.domain}
                          </Text> */}
                        </Card>
                      </CardSection>
                    );
                  })}
                </Grid>
              </ScrollArea>
            </Box>
          </Container>
        </>
      );
    } else {
      if (user.mentees.length == 0) {
        return (
          <Container
            style={{ marginTop: 100, paddingLeft: "0px", paddingRight: "0px" }}
          >
            <Text className="Mentor-style">No Mentees Found</Text>
          </Container>
        );
      } else {
        return (
          <>
            <Container
              style={{
                marginTop: 35,
                width: "100%",
                paddingLeft: "0px",
                paddingRight: "0px",
              }}
            >
              <Text className="Mentor-style">Mentees</Text>
              <Tabs
                grow
                styles={(theme) => ({
                  tabControl: {
                    color:
                      theme.colorScheme === "dark"
                        ? theme.colors.dark[0]
                        : theme.colors.gray[0],
                    fontSize: isScreenLarge == false ? 15 : 20,
                    padding: `${theme.spacing.xl}px ${theme.spacing.xl}px`,
                  },

                  tabActive: {
                    backgroundColor:
                      theme.colorScheme === "dark"
                        ? theme.colors.dark[6]
                        : theme.white,
                    borderColor: theme.colors.blue[7],
                    color:
                      theme.colorScheme === "dark"
                        ? theme.colors.dark[0]
                        : theme.colors.dark[9],
                  },
                })}
              >
                {user.mentees.map((domain) => {
                  return (
                    <Tabs.Tab
                      label={domain.domain.name}
                      key={String(domain.domain.name)}
                    >
                      <Box
                        sx={(theme) => ({
                          backgroundColor:
                            theme.colorScheme === "dark"
                              ? theme.colors.dark[6]
                              : theme.colors.gray[2],
                          textAlign: "center",
                          padding: theme.spacing.xl,
                          // borderRadius: theme.radius.md,
                          cursor: "pointer",
                          height: 415,

                          "&:hover": {
                            backgroundColor:
                              theme.colorScheme === "dark"
                                ? theme.colors.dark[6]
                                : theme.colors.gray[3],
                          },
                        })}
                      >
                        <ScrollArea style={{ height: 390 }} offsetScrollbars>
                          <Grid justify="space-around">
                            {domain.domain.members.map((mentee) => {
                              return (
                                <CardSection
                                  key={
                                    String(mentee.id) +
                                    String(mentee.roll) +
                                    String(domain.domain.name)
                                  }
                                  style={{ margin: 10 }}
                                >
                                  <Card
                                    style={{
                                      height: 355,
                                      width: isScreenLarge == false ? 240 : 275,
                                      borderRadius: 15,
                                      marginBottom: 25,
                                      backgroundColor:
                                        theme.colorScheme === "dark"
                                          ? theme.colors.dark[8]
                                          : "white",
                                    }}
                                  >
                                    <Image
                                      src={
                                        mentee.gender == "FEMALE"
                                          ? "/female.png"
                                          : "/male.png"
                                      }
                                      height={150}
                                      width={150}
                                      radius="md"
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    />
                                    <ScrollArea style={{ height: 190,wordBreak:"break-word" }}>
                                      <Container>
                                        <Text
                                          style={{
                                            fontSize: 18,
                                            textAlign: "left",
                                            marginTop: 10,
                                          }}
                                        >
                                          Name: {mentee.name}
                                        </Text>
                                        <Text
                                          style={{
                                            fontSize: 16,
                                            textAlign: "left",
                                            marginTop: 12,
                                          }}
                                        >
                                          Roll Number: {mentee.roll}
                                        </Text>
                                        
                                        <Text
                                          style={{
                                            fontSize: 16,
                                            textAlign: "left",
                                            marginTop: 10,
                                            marginBottom: 10,
                                          }}
                                        >
                                          Department: {mentee.department}
                                        </Text>
                                        <Text
                                          style={{
                                            fontSize: 16,
                                            textAlign: "left",
                                            marginTop: 10,
                                            marginBottom: 10,
                                          }}
                                        >
                                          Phone Number: {mentee.phone}
                                        </Text>
                                      </Container>
                                    </ScrollArea>
                                  </Card>
                                </CardSection>
                              );
                            })}
                          </Grid>
                        </ScrollArea>
                      </Box>
                    </Tabs.Tab>
                  );
                })}
              </Tabs>
              <ContactCards />
            </Container>
          </>
        );
      }
    }
  }
};
